import { combineReducers } from 'redux';
import LoginReducer from './LoginReducer';
import DetailsReducer from './DetailsReducer';
import SelectedTypeReducer from './SelectedTypeReducer';
import PassportDetailsReducer from './PassportDetailsReducer';

const Reducers = combineReducers({
    Login: LoginReducer,
    Details: DetailsReducer,
    SelectedType: SelectedTypeReducer,
    PassportDetails: PassportDetailsReducer
})

export default Reducers;